// JR RED - front-end JavaScript entry point.
import { navDesktop, navClick } from './modules/navigation';
import initOffcanvas from './offcanvas';
import initTopbarSearch from './modules/topbar-search';
import backToTop from './modules/top';
import initLoadMore from './load-more';

// header.php sets body_class('no-js'); swap it for 'js' now that scripting
// is available, so the .js/.no-js progressive-enhancement selectors in
// navigation/_nav-desktop.scss (hover dropdowns) take effect.
document.body.classList.remove('no-js');
document.body.classList.add('js');

// Desktop hover dropdowns + click/keyboard dropdown toggling for the
// primary menu. Both are wired against the topbar's "main-menu" instance
// and, for navClick(), the offcanvas's "offcanvas-menu" instance too
// (its selectors are class-based, not id-scoped - see topbar.php and
// offcanvas.php). navMobile() from the same module is intentionally not
// called here: it targets #menu-items-wrapper, which this header doesn't
// render - template-parts/header/offcanvas.php + offcanvas.js own the
// mobile drawer instead.
navDesktop();
navClick();

initOffcanvas();

// Task ("buscador", 2026-08-13): topbar's "search pill" - no-op on any
// page/width that doesn't render .topbar__search (the offcanvas drawer's
// own search form needs no JS, see offcanvas.php).
initTopbarSearch();

// Task 7: air-light already ships the back-to-top button markup
// (footer.php's #top anchor) and its styles (features/_top.scss) - this
// module (modules/top.js) existed too but was never imported/called, so
// the button rendered but never appeared or scrolled. Wiring it up here.
backToTop();

// Task 9: home page "load more" button - no-op on any page that doesn't
// render #jr-load-more (initLoadMore() returns early when it's missing).
initLoadMore();
